import React, { FC } from "react";

import { Text } from "@sitecore-jss/sitecore-jss-react";
import LineItem from "./components/lineItem";
import { appendToUrlPath } from "../../utils";
import { ExploreEquipmentModel } from "./model/ExploreEquipment.model";
import { TExploreEquipmentProps } from "./types/ExploreEquipment.types";

import "./style.scss";

const ExploreEquipment: FC<TExploreEquipmentProps> = (props) => {
  const model = new ExploreEquipmentModel(props);
  const lineItems = model?.productListData?.items || [];

  return (
    <section className="explore-equipment">
      <div className="explore-equipment__container">
        <Text
          field={model.title}
          className="explore-equipment__title"
          tag="h2"
        />
        <div className="explore-equipment__line-listing">
          {lineItems.map((lineItem, i) => (
            <LineItem
              url={appendToUrlPath(model.url, lineItem.titleUrl)}
              lineItem={lineItem}
              key={`line-item-${i}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExploreEquipment;
